import HelpIcon from '@mui/icons-material/Help';
import { Box, useTheme } from '@mui/material';
import { contentAgresivo, contentConservador, contentModerado } from '../../../utils/constants';
import { ButtonsPrimary, ButtonsSecondary } from '../../ComponentApp/buttoms';
import SelectorImput from '../../profile/SelectorImput';
import HeaderLayout from '../Header/HeaderLayout';
import {
  BodyContainer,
  ButtonsStack,
  HelpLinkStack,
  IconsRiskProfile,
  ProfileActionsBox,
  ProfileImageBox,
  ProfileInfoContainer,
  ProfileWrapper,
  RiskOptionsStack,
  StyledHelpLink,
  TitleContainer,
  TitleStepeBox,
  TitleText,
} from './StyledComponentsProfile';
import { TitleStepe } from './TitleStepe';

export const ProfileContent = ({
  user,
  selectedContent,
  selectedTitle,
  handleSelect,
  handleGoToQuestions,
  handleClickOpen,
  handleRiskProfile,
  navigate,
}) => {
  const theme = useTheme();
  return (
    <>
      <HeaderLayout type='riskSelection' />
      <ProfileWrapper>
        <TitleContainer>
          <TitleText>Mi Perfil de inversiones</TitleText>
        </TitleContainer>
        <BodyContainer>
          <ProfileInfoContainer>
            <ProfileImageBox>
              <IconsRiskProfile
                src={
                  selectedContent === null
                    ? '/assets/images/perfil-noDefined.svg'
                    : handleRiskProfile(selectedTitle.toLowerCase())
                }
              />
            </ProfileImageBox>
            <TitleStepeBox>
              <TitleStepe user={user} description={selectedContent} />
            </TitleStepeBox>
          </ProfileInfoContainer>

          <ProfileActionsBox>
            <RiskOptionsStack>
              <SelectorImput
                TitleContent='Conservador'
                contentProfile={contentConservador}
                selected={selectedTitle === 'Conservador'}
                onSelect={handleSelect}
              />
              <SelectorImput
                TitleContent='Moderado'
                contentProfile={contentModerado}
                selected={selectedTitle === 'Moderado'}
                onSelect={handleSelect}
              />
              <SelectorImput
                TitleContent='Agresivo'
                contentProfile={contentAgresivo}
                selected={selectedTitle === 'Agresivo'}
                onSelect={handleSelect}
              />
              <HelpLinkStack>
                <HelpIcon sx={{ color: theme.palette.primary.main }} />
                <StyledHelpLink component='button' onClick={handleGoToQuestions}>
                  No estoy seguro de mi perfil, ayúdenme a descubrirlo
                </StyledHelpLink>
              </HelpLinkStack>

              <ButtonsStack>
                <Box sx={{ width: { xs: '100%', sm: '250px' } }}>
                  <ButtonsSecondary name='Volver' onClick={() => navigate(-1)} fullWidth />
                </Box>
                <Box sx={{ width: { xs: '100%', sm: '250px' } }}>
                  <ButtonsPrimary
                    name='Es mi perfil'
                    onClick={() => handleClickOpen(selectedTitle)}
                    disabled={selectedTitle === null}
                    fullWidth
                    sx={{ whiteSpace: 'nowrap' }}
                  />
                </Box>
              </ButtonsStack>
            </RiskOptionsStack>
          </ProfileActionsBox>
        </BodyContainer>
      </ProfileWrapper>
    </>
  );
};
